import { useMemo } from "react";

import clsx from "clsx";

import { CampaignsGrid } from "features/campaigns";

export const BrandCampaigns = ({ brand_id, className, ...props }) => {
  const classes = clsx("brand-campaigns", className);
  const filterParams = useMemo(() => {
    return {
      brand_id,
    };
  }, [brand_id]);
  return (
    <CampaignsGrid
      filterParams={filterParams}
      className={classes}
      gridId="brand-campaigns"
      excludeDataSources="brand"
    />
  );
};
